import { useMemo } from "react";
import { useSession, useSessionManager } from "../store/session/SessionProvider";
import { createFieldApi } from "../lib/api/fieldApi";
import type { FieldApi } from "../lib/api/fieldApi";

/** 현재 세션 코스의 FS-02 API(세션이 없으면 null) */
export function useFieldApi(): FieldApi | null {
  const manager = useSessionManager();
  const state = useSession();
  const courseId = state.status === "ready" ? state.session.courseId : null;
  return useMemo(
    () => (courseId ? createFieldApi(manager.request, courseId) : null),
    [manager, courseId],
  );
}
